<template>
  <header class="flex-header">
    <div class="flex"><slot name="flex"></slot></div>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'FlexHeader',
  props: {
    left: {
      default: ''
    },
    center: {
      default: ''
    },
    right: {
      default: ''
    }
  }
}
</script>

<style scoped>
header {
  height: calc(100vh - 5rem);
  display: flex;
  flex-direction: column;
}

header > .flex {
  display: flex;
  flex: 1;
  margin: 0 2rem;
  width: calc(100% - 4rem);
  position: relative;
  border-radius: var(--br);
  overflow: hidden;
  position: relative;
  z-index: 4;
}
</style>

<style>
.safari header.flex-header {
  height: calc(88.5vh - 5rem);
}
</style>